// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-fab-button {
  position: absolute;
  bottom: 10px;
  right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/reporthtml-list/reporthtml-list.component.scss","webpack://./src/components/general%20components/reporthtml-list/reporthtml-list.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;ACCJ","sourcesContent":["ion-fab-button {\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n  }","ion-fab-button {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
